import * as React from "react";
const useScrollIntoView = (defaultScrollOptions) => {
  const elementRef = React.useRef(null);
  const triggerScroll = React.useCallback(
    (overrideOptionsPerScroll) => {
      if (!elementRef.current) {
        return;
      }
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      elementRef.current.scrollIntoView({
        behavior: prefersReducedMotion ? "auto" : "smooth",
        ...defaultScrollOptions,
        ...overrideOptionsPerScroll
      });
    },
    [defaultScrollOptions]
  );
  return { elementRef, triggerScroll };
};
export {
  useScrollIntoView
};
//# sourceMappingURL=use-scroll-into-view.js.map
